import EnsurePermission from '../EnsurePermission';
import Spinner from '../Spinner';
import {Dispatch, FC} from 'react';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import IconButton from '@mui/material/IconButton';

type ViewModeProps = {
  label: string,
  permission: Nullable<string[]>,
  isUpdating: boolean,
  setEditMode: Dispatch<boolean>
}

const ViewMode: FC<ViewModeProps> = ({
  label,
  permission,
  isUpdating,
  setEditMode
}) => (
  <div className="editable-cell">
    <span className="cell-content">{label}</span>
    <EnsurePermission elementPermissions={permission}>
      <IconButton
        disabled={isUpdating}
        className="edit-icon icon-button gray small"
        onClick={() => setEditMode(true)}
      >
        {isUpdating ? <Spinner embedded /> : <ModeEditIcon className="icon" fontSize="small" />}
      </IconButton>
    </EnsurePermission>
  </div>
);

export default ViewMode;
